'use strict';

module.exports = function(state) {
	var isPausedBecauseNotInView = state === 'isPausedBecauseNotInView';
	if (!isPausedBecauseNotInView) {
		this.isPaused = false;
	}
	this.isCleared = false;
	this.animation = requestAnimationFrame(this.animateColors.bind(this));
};



//////////////////
// WEBPACK FOOTER
// ./~/granim/lib/play.js
// module id = 24
// module chunks = 0